import React from 'react';
import { GtxReactPage, VIEWPORT_MEDIA_QUERIES } from './GtxApp';
import { createOuterWrapper } from './createOuterWrapper';
import { Route } from 'react-router-dom';
import { GtxAppContextProvider } from './GtxAppContextProvider';
import { MediaQuery } from '../MediaQuery';
import { DefaultTopHeaderPortal } from './DefaultTopHeaderPortal';

/**
 * Creates the routes for the application
 * it will render portals for each page
 * and will use the outer wrapper to provide the necessary context and providers for the page
 */
export const createRoutes = (
    pages: GtxReactPage[],
    pagesPortals: any[],
    setInitialData: (data: unknown) => void,
    initialData: unknown,
    qsPayload: Record<string, string>
) => {
    return pages.map((pageItm) => {
        const Wrapper = pageItm.wrapper || React.Fragment;
        const hideHeader = pageItm.header === false;
        const HeaderComponent = pageItm.header ? pageItm.header.actions : null;

        const OuterWrapper = createOuterWrapper(
            pageItm,
            setInitialData,
            hideHeader
        );

        return (
            <Route
                key={pageItm.path}
                path={pageItm.path}
                element={
                    <OuterWrapper>
                        {[
                            pagesPortals.find(
                                (portalItm) => pageItm.path === portalItm.path
                            ),
                        ].map((item) => {
                            const PortalComponent = item?.portal;
                            const hideOnMobile =
                                pageItm.header && pageItm.header?.hideOnMobile;
                            const customTitle = pageItm.header
                                ? pageItm.header?.customTitle
                                : undefined;
                            const actions = pageItm.header
                                ? pageItm.header?.actions
                                : null;

                            return (
                                <GtxAppContextProvider
                                    initialData={initialData}
                                    key={`portal-content-${pageItm.path}`}
                                    goBack={
                                        item?.goBack ? item.goBack : () => {}
                                    }
                                >
                                    <Wrapper>
                                        <MediaQuery
                                            queries={VIEWPORT_MEDIA_QUERIES}
                                        >
                                            {(match) => {
                                                return (
                                                    (((match.isDesktop ||
                                                        match.isLargeDesktop) &&
                                                        hideOnMobile) ||
                                                        !hideOnMobile) &&
                                                    !hideHeader && (
                                                        <DefaultTopHeaderPortal
                                                            customTitle={
                                                                customTitle
                                                            }
                                                            actions={
                                                                HeaderComponent && (
                                                                    <HeaderComponent />
                                                                )
                                                            }
                                                        />
                                                    )
                                                );
                                            }}
                                        </MediaQuery>
                                        {PortalComponent && (
                                            <PortalComponent
                                                queryString={qsPayload}
                                                headerActions={
                                                    actions && actions
                                                }
                                            />
                                        )}
                                    </Wrapper>
                                </GtxAppContextProvider>
                            );
                        })}
                    </OuterWrapper>
                }
            />
        );
    });
};
